module.exports = __webpack_public_path__ + "img/imagen1.8ca5fb5c.png";